import { render, staticRenderFns } from "./MonitorRTC.vue?vue&type=template&id=65b16cfb&scoped=true&"
import script from "./MonitorRTC.vue?vue&type=script&lang=js&"
export * from "./MonitorRTC.vue?vue&type=script&lang=js&"
import style0 from "./MonitorRTC.vue?vue&type=style&index=0&id=65b16cfb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b16cfb",
  null
  
)

export default component.exports